import { Vector3, Box3 } from '../../src/js/three.module.js';

/**
 * Selvitetään, onko tarvetta uudelleensijoittaa annettu (position + delta), kun tehdään rajaus että tämän on oltava annetun boundingBox:in sisällä
 */
		
const new_position = new Vector3();

/**
 * 
 * @param {Box3} boundingBox 
 * @param {Vector3} position 
 * @param {Vector3} delta 
 * @returns 
 */
export function restrictPositionIntoBoundingBox( boundingBox, position, delta = new Vector3( 0, 0, 0 ) ) {

    new_position.copy( position ).add( delta );

    let restriced = false;

    if (new_position.x < boundingBox.min.x) { new_position.x = boundingBox.min.x; restriced = true; }
    if (new_position.x > boundingBox.max.x) { new_position.x = boundingBox.max.x; restriced = true; }

    if (new_position.y < boundingBox.min.y) { new_position.y = boundingBox.min.y; restriced = true; }
    if (new_position.y > boundingBox.max.y) { new_position.y = boundingBox.max.y; restriced = true; }

    if (new_position.z < boundingBox.min.z) { new_position.z = boundingBox.min.z; restriced = true; }
    if (new_position.z > boundingBox.max.z) { new_position.z = boundingBox.max.z; restriced = true; }
    
    if (restriced) {

        delta.copy( new_position ).sub( position );

        return delta;
    }
}